<div class="header" [ngClass]="headerClasses" [tabindex]="tabIndex" (click)="emitOrdering()" (keydown.enter)="emitOrdering()">
  <span><ng-content /></span>
  @if (orderingProperty()) {
    <chr-sort-icon [ascend]="ascend" [descend]="descend" size="s" />
  }
</div>
